import { ArrowRight, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";

// Sprint 10.x Phase B — Empty state pour /strategy quand aucun rapport
// `revenue_reports` n'a encore été généré. Cohérent visuellement avec les
// autres banners IA du CRM (BriefIABanner, BriefDailyBanner).

interface StrategyEmptyProps {
  onGenerate: () => void;
  disabled: boolean;
}

export function StrategyEmpty({ onGenerate, disabled }: StrategyEmptyProps) {
  return (
    <div className="rounded-xl border bg-gradient-to-b from-violet-50 to-violet-100/50 border-violet-200 dark:from-violet-950/30 dark:to-violet-900/20 dark:border-violet-900/40 px-6 py-8">
      <div className="flex flex-col items-center gap-3 text-center max-w-md mx-auto">
        <div className="size-10 rounded-lg bg-violet-100 text-violet-700 dark:bg-violet-950/60 dark:text-violet-300 flex items-center justify-center">
          <Sparkles className="size-5" />
        </div>
        <div>
          <p className="text-[14px] font-semibold text-foreground">
            Pas encore de rapport stratégique
          </p>
          <p className="text-[13px] text-muted-foreground mt-1">
            Génère le premier rapport pour identifier les bottlenecks revenu,
            les segments à prioriser et les prochaines actions.
          </p>
        </div>
        <Button
          type="button"
          size="sm"
          onClick={onGenerate}
          disabled={disabled}
          className="gap-1.5 mt-1"
        >
          <Sparkles className="size-3.5" />
          Générer le rapport
          <ArrowRight className="size-3.5" />
        </Button>
      </div>
    </div>
  );
}
